module.exports = __webpack_public_path__ + "img/password-dots.1b91a95f.svg";